"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PusherEvent = void 0;
var PusherEvent;
(function (PusherEvent) {
    PusherEvent["ThumbStarted"] = "thumb_started";
    PusherEvent["ThumbDone"] = "thumb_done";
    PusherEvent["TrackClick"] = "track_click";
    PusherEvent["TrackVideo"] = "track_video";
    PusherEvent["TrackPage"] = "track_page";
    PusherEvent["TrackVisit"] = "track_visit";
    PusherEvent["Comment"] = "comment";
    PusherEvent["Sealed"] = "sealed";
    PusherEvent["SealFailed"] = "seal_failed";
    PusherEvent["DownloadDocumentResponse"] = "download_document_response";
})(PusherEvent = exports.PusherEvent || (exports.PusherEvent = {}));
